import { Button, Header, Modal } from '@mairistem/composants';
import React from 'react';

import { formatMonetaire } from '@/utils';

type ModalPrelevementValidationProps = {
  nombreFactures: number;
  montantTotal: number;
  onClose: () => void;
  onValidate: () => Promise<boolean>;
};

const ModalPrelevementValidation = (props: ModalPrelevementValidationProps) => {
  const { nombreFactures, montantTotal, onClose, onValidate } = props;

  const [loading, setLoading] = React.useState(false);

  const handleValidateClick = React.useCallback(async () => {
    setLoading(true);

    const response = await onValidate();

    if (response) {
      onClose();
    } else {
      setLoading(false);
    }
  }, [onClose, onValidate]);

  return (
    <Modal
      open
      size="small"
      {...(!loading && {
        closeIcon: true,
        onClose,
      })}
    >
      <Modal.Header>Générer les reçus</Modal.Header>
      <Modal.Content scrolling={false}>
        <Header>
          <Header.Subheader>
            <b>{nombreFactures}</b>{' '}
            {nombreFactures === 1
              ? ' facture avec prélèvement a été sélectionnée '
              : ' factures avec prélèvement ont été sélectionnées '}
            pour un montant {nombreFactures > 1 && 'total '}
            de <b>{formatMonetaire(montantTotal, 2, true)}</b>.
          </Header.Subheader>
        </Header>
        <Header>
          <Header.Subheader>
            {nombreFactures === 1
              ? 'Êtes-vous sûr de vouloir générer le reçu ?'
              : 'Êtes-vous sûr de vouloir générer les reçus ?'}
          </Header.Subheader>
        </Header>
      </Modal.Content>
      <Modal.Actions>
        <Button
          data-testid="button-close"
          onClick={onClose}
          basic
          size="tiny"
          icon="close"
          content="Annuler"
          disabled={loading}
          loading={loading}
        />
        <Button
          data-testid="button-validate"
          positive
          onClick={handleValidateClick}
          content="Confirmer la génération"
          icon="checkmark"
          disabled={loading}
          loading={loading}
        />
      </Modal.Actions>
    </Modal>
  );
};

export default ModalPrelevementValidation;
